<template>
  <div class="wrapper">
    <van-search
      v-model="value"
      shape="round"
      background="#F8F8F8"
      placeholder="搜索科室名称"
      @input="handleQuery"
    >
      <template v-slot:left-icon>
        <img src="@/assets/payment/sousuo_icon.png" class="ss_icon">
      </template>
    </van-search>
    <div class="show_class">
      <div class="hot">
        <ul>
          <li @click="doctorSel(item)" v-for="item in list" :key="item.deptCode">{{item.deptName}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { selectBDeptinfo } from "@/request/api.js"
export default {
  data() {
    return {
      value: "",
      list: [],
      num: ""
    }
  },
  created() {
    let loadDataUrl = window.location.href;
    this.num = loadDataUrl.split("?")[1];
    this.handleQuery();
  },
  methods: {
    async handleQuery(){
      let map = {
        deptName: this.value,
        hospCode: this.num,
        queryRequest: {
          pageNum: 1,
          pageSize: 999,
          sortField: "",
          sortOrder: ""
        }
      }
      let res = await selectBDeptinfo(map);
      this.list = res.data.obj.records
    },
    doctorSel(item){
      sessionStorage.setItem("keyDepartment",JSON.stringify(item))
      this.$router.push("/DepartmentDoctor")
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F8F8F8;
  .ss_icon{
    position: relative;
    top: 2px;
    width: 11px;
    height: 13px;
  }
  /deep/ .van-search__content--round{
    background: #E4E4E4;
  }
  .show_class{
    display: flex;
    flex-flow: column nowrap;
    padding: 0px 7px 29px;
    .hot{
      margin-top: 20px;
    }
    .other{
      margin-top: 36px;
    }
    >div{
      >p{
        font-size: 17px;
        font-weight: bold;
        margin-bottom: 9px;
      }
      >ul{
        font-size: 14px;
        // display: flex;
        // flex-flow: row wrap;
        // justify-content: space-between;
        // justify-items: center;
        >li{
          display: inline-block;
          margin: 14px 7px 0px;
          padding: 10px 0px;
          width: 106px;
          text-align: center;
          color: #fff;
          background: #2A9DCE;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/website/KeyDepartments.vue